import { MAX_DIMENSION, JPEG_QUALITY } from './imageConfig';
import { IMAGE_PROCESSING_ERRORS } from './validateImageSize';

const preScaleWithCanvas = async (source, outputName) => {
  const objectUrl = URL.createObjectURL(source);
  const img = document.createElement('img');
  img.src = objectUrl;

  const canvas = document.createElement('canvas');
  let result;

  try {
    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = () =>
        reject(new Error(IMAGE_PROCESSING_ERRORS.CORRUPT_ERROR));
    });

    const scale = Math.min(1, MAX_DIMENSION / Math.max(img.width, img.height));

    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);

    const ctx = canvas.getContext('2d');

    if (!ctx) {
      throw new Error(IMAGE_PROCESSING_ERRORS.MEMORY_ERROR);
    }

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    const blob = await new Promise((resolve) =>
      canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY)
    );

    if (!blob) {
      throw new Error(IMAGE_PROCESSING_ERRORS.MEMORY_ERROR);
    }

    result = new File([blob], outputName, { type: 'image/jpeg' });
  } finally {
    URL.revokeObjectURL(objectUrl);
    canvas.width = 0;
    img.src = '';
  }

  return result;
};

export default preScaleWithCanvas;
